export default __webpack_public_path__ + "ac99c9f537c418437be425841a4c74b4.jpg";